import { useAddToCartFlow } from '~~/app/composables/useAddToCartFlow'
import { useToggleWishlistMutation } from '~~/app/composables/queries/useStoreApi'
import { useQuickView } from '~~/app/composables/useQuickView'

/**
 * Most akcji sklepu dla zewnętrznych skryptów (widgety rekomendacji/personalizacji
 * Segmentify). Wystawia `window.__storefront`:
 *  - addToCart(productId, { productAttributeId?, quantity? }) → Promise
 *  - toggleWishlist(productId, isFavorite?)   // isFavorite=true ⇒ usuń z ulubionych
 *  - openQuickView(slug)                      // slug produktu (z linku w feedzie)
 *
 * productId = NUMERYCZNE id_product (= feed GMC g:id, to samo co POST /rest/cart).
 *
 * Kompozycje instancjonowane LENIWIE przy pierwszym użyciu przez runWithContext,
 * więc kolejność pluginów ani brak kontekstu Vue w callbacku partnera nie mają
 * znaczenia (partner woła to długo po inicjalizacji aplikacji).
 */
export default defineNuxtPlugin((nuxtApp) => {
  type AddOpts = { productAttributeId?: number, quantity?: number }

  let flow: ReturnType<typeof useAddToCartFlow> | null = null
  let wishlist: ReturnType<typeof useToggleWishlistMutation> | null = null

  const w = window as Window & {
    __storefront?: {
      addToCart: (productId: number | string, opts?: AddOpts) => Promise<void> | void
      toggleWishlist: (productId: number | string, isFavorite?: boolean) => void
      openQuickView: (slug: string) => void
    }
  }

  w.__storefront = {
    addToCart(productId, opts) {
      flow ??= nuxtApp.runWithContext(() => useAddToCartFlow()) as ReturnType<typeof useAddToCartFlow>
      return flow.add({
        productId: Number(productId),
        productAttributeId: opts?.productAttributeId,
        quantity: opts?.quantity,
      })
    },
    toggleWishlist(productId, isFavorite = false) {
      wishlist ??= nuxtApp.runWithContext(() => useToggleWishlistMutation()) as ReturnType<typeof useToggleWishlistMutation>
      wishlist.mutate({ productId: String(productId), isFavorite })
    },
    openQuickView(slug) {
      useQuickView().open(String(slug))
    },
  }
})
